module.exports = __webpack_public_path__ + "static/hamburger-guel-b4fcea22d4b666e74e3a047fcf870e50.jpg";